import API from "@aws-amplify/api";
import gql from "graphql-tag";
import { readEntity, updateEntity } from "../../data/delicDataClient";
import { handleError } from "../../utils/basic";

const ACCEPT_TERMS_AND_CONDITIONS = gql`
    mutation acceptTermsAndConditions($cognitoId: String!, $input: PersonInput) {
        AcceptTermsAndConditions(cognitoId: $cognitoId, input: $input) {
            id
            acceptedDelicTandCs
            customerId
        }
    }
`;

export async function updatePerson(dispatch, { input, callBack }) {
    try {
        const res = await updateEntity("Person", { input });
        if (res) {
            dispatch({ type: "fetched", payload: res });
            if (callBack) {
                callBack();
            }
        } else {
            throw new Error("Error updating Person");
        }
    } catch (e) {
        handleError(e);
    }
}

export async function acceptTermsAndConditions(dispatch, { cognitoId, input, callBack }, state) {
    try {
        const graphqlOperation = {
            query: ACCEPT_TERMS_AND_CONDITIONS,
            variables: { cognitoId, input },
            authMode: "AWS_IAM"
        };
        const response = await API.graphql(graphqlOperation);
        const res = response.data.AcceptTermsAndConditions;
        if (res) {
            dispatch({ type: "fetched", payload: { ... state, ...res} });
            if (callBack) {
                callBack();
            }
        } else {
            throw new Error("Error updating Person");
        }
    } catch (e) {
        handleError(e);
    }
}

export async function fetchPerson(dispatch, { accountId, callBack }) {
    try {
        const res = await readEntity("PersonByAccountId", { accountId });
        if (res) {
            dispatch({ type: "fetched", payload: res });
            if (callBack) {
                callBack();
            }
        } else {
            throw new Error("Error fetching PublicProfile");
        }
    } catch (e) {
        handleError(e);
    }
}

export async function getFounderMemberStatus({ hubspotId, callBack }) {
  try {
    const founderMemberStatusResponse = await readEntity("FounderMemberStatus", { hubspotId });
    if (callBack) {
      callBack(founderMemberStatusResponse);
    }
  } catch (e) {
    handleError(e);
  }
}
